import {
    Tooltip
} from 'bootstrap';
import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-fade';
import 'flickity-fullscreen';
import AOS from 'aos';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import ModuloBox from './plugins/modulobox.js';
import './plugins/readmore.js';
import './plugins/campaign.js';
import Mixitup from 'mixitup';
import axios from 'axios';

require('./search-autocomplete');
import gsap from "gsap";
import scrollTrigger from "gsap/ScrollTrigger";
import {
    CountUp
} from 'countup.js';

gsap.registerPlugin(scrollTrigger);

if(document.querySelector('body[data-lang="nl"]')) {
    setTimeout(() => {
        const topBar = '<div class="top-bar bg-jic"><h5 class="text-center mb-4">Blijf gezond in de zorg | Doe de Til- en Transferscan!</h5> <a href="/nl/blijf-gezond-in-de-zorg">Meer info</a></div>';

        document.querySelector('body').insertAdjacentHTML('afterbegin', topBar);
        const topBarElement        = document.querySelector('.top-bar');
        const navBar               = document.querySelector('nav.navbar.navbar-expand-xl');
        topBarElement.style.height = topBarElement.scrollHeight + 'px';
        topBarElement.style.top    = navBar.scrollHeight - 1 + 'px';

        document.addEventListener('scroll', (event) => {
            let paddingTop                                  = topBarElement.clientHeight - window.scrollY;
            paddingTop                                      = paddingTop <= 0 ? 0 : paddingTop;
            document.querySelector('body').style.paddingTop = paddingTop + 'px';
        });
        setTimeout(() => {
            document.dispatchEvent(new Event('scroll'));
        }, 400);
    }, 500);
}

// Init Animate On Scroll
AOS.init();

if(document.querySelector('[data-count-up]')) {
    window.addEventListener('scroll', (event) => {
        document.querySelectorAll('.do-countup').forEach((el) => {
            const countUp = el.querySelector('[data-count-up]');
            if(el.classList.contains('aos-animate') && countUp && !countUp.classList.contains('started')) {
                countUp.classList.add('started');
                const options = {
                    duration:  3,
                    separator: '.',
                    decimal:   ',',
                };

                if(countUp.dataset.countUp.match(/\./)) {
                    options.decimalPlaces = countUp.dataset.countUp.split('.')[1].length;
                }
                new CountUp(countUp, countUp.dataset.countUp, options).start();
            }
        });
    });

    setTimeout(() => {
        window.dispatchEvent(
            new Event('scroll')
        );
    }, 100);
}

// Remove background-img border
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

// Enable BS Tooltips everywhere
const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
tooltipTriggerList.map((tooltipTriggerEl) => {
    return new Tooltip(tooltipTriggerEl)
});

// Keeps dropdowns open after click on item in the dropdown.
const keepOpenDropdowns = Array.from(document.querySelectorAll('ul.dropdown-menu[data-keep-open-on-click="true"]'));
keepOpenDropdowns.map((element) => {
    element.addEventListener('click', (e) => {
        e.stopPropagation();
    });
});

const submitForm = (gRecaptchaResponse) => {
    const form = document.getElementById('form');

    const submitButton = form.querySelector('[type="submit"]');
    submitButton.classList.add('disabled');
    submitButton.disabled  = true;
    submitButton.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Laden...</span></div>';

    const formData = new FormData(form);
    formData.append('g-recaptcha-response', gRecaptchaResponse);

    const validationAlert = document.getElementById('form-validation');
    validationAlert.classList.add('hidden');
    validationAlert.classList.remove('alert-danger');

    document.querySelectorAll('.invalid-feedback').forEach((element) => {
        if(!element.classList.contains('d-none')) {
            element.classList.add('d-none');
        }
    });

    document.querySelectorAll('.is-invalid').forEach((element) => {
        element.classList.remove('is-invalid');
    });

    axios.post(window.location.href, formData).then((response) => {
        if(response.data.success) {
            validationAlert.innerHTML = response.data.message;
            validationAlert.classList.add('alert-success');
            validationAlert.classList.remove('d-none');

            if(form.classList.contains('skincair-form')) {
                fbq('track', 'JIC-Lead-SkinCair');
                gtag('event', 'submit', {
                    'event_category': 'skincair',
                    'event_label':    'skincair-form',
                    'value':          1
                });
            }

            if(form.classList.contains('touch-and-move-form')) {
                fbq('track', 'JIC-Lead-TouchAndMove');
                gtag('event', 'submit', {
                    'event_category': 'Touch & Move',
                    'event_label':    'touch-and-move-form',
                    'value':          1
                });
            }

            form.innerHTML = '';
        }
    }).catch((exception) => {
        if(exception.response.data.errors) {
            for(let error in exception.response.data.errors) {
                const el = form.querySelector('[name="' + error + '"]');
                el.classList.add('is-invalid');
                if(el.parentNode.querySelector('.d-none') !== null) {
                    el.parentNode.querySelector('.d-none').classList.remove('d-none');
                }
            }
        }

        submitButton.classList.remove('disabled');
        submitButton.disabled  = false;
        submitButton.innerHTML = 'Verstuur bericht';
    });
}

window.submitForm = submitForm;

const submitCampaignForm = (gRecaptchaResponse) => {
    const form = document.getElementById('form');

    const submitButton = form.querySelector('[type="submit"]');
    submitButton.classList.add('disabled');
    submitButton.disabled  = true;
    submitButton.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Laden...</span></div>';

    const formData = new FormData(form);
    formData.append('g-recaptcha-response', gRecaptchaResponse);

    const validationAlert = document.getElementById('form-validation');
    validationAlert.classList.add('hidden');
    validationAlert.classList.remove('alert-danger');

    document.querySelectorAll('.invalid-feedback').forEach((element) => {
        if(!element.classList.contains('d-none')) {
            element.classList.add('d-none');
        }
    });

    document.querySelectorAll('.is-invalid').forEach((element) => {
        element.classList.remove('is-invalid');
    });

    if(localStorage.getItem('quickscan-results')) {
        const localStorageItem = JSON.parse(localStorage.getItem('quickscan-results'));
        for(let key in localStorageItem) {
            if(key.match(/question[1-3]/)) {
                formData.append('quickscan_results[' + key + ']', localStorageItem[key]);
            }
        }
    }

    axios.post(window.location.href, formData).then((response) => {
        if(response.data.success) {
            validationAlert.innerHTML = response.data.message;
            validationAlert.classList.add('alert-success');
            validationAlert.classList.remove('d-none');

            fbq('track', 'CompleteRegistration');
            console.log('Complete Registration trigger!');

            form.remove();
        }
    }).catch((exception) => {
        if(exception.response.data.errors) {
            for(let error in exception.response.data.errors) {
                const el = form.querySelector('[name="' + error + '"]');
                el.classList.add('is-invalid');
                if(el.parentNode.querySelector('.d-none') !== null) {
                    el.parentNode.querySelector('.d-none').classList.remove('d-none');
                }
            }
        }

        submitButton.classList.remove('disabled');
        submitButton.disabled  = false;
        submitButton.innerHTML = 'Verstuur bericht';
    });
}

window.submitCampaignForm = submitCampaignForm;

const combineArrays = ([head, ...[headTail, ...tailTail]]) => {
    if(!headTail) return head;

    const combined = headTail.reduce((acc, x) => {
        return acc.concat(head.map(h => `${h}${x}`))
    }, []);

    return combineArrays([combined, ...tailTail]);
}

if(document.querySelector('.filter-container')) {
    const extractProductFiltersFromUrl = () => {
        let filters = '.' + location.search.replace(/^\?filters=/, '').replace(/,/g, '.');

        if(filters === '.') {
            filters = '.filter-item';
        }

        document.querySelectorAll('.filter-input').forEach((filterItem) => {
            filterItem.checked = false;
        });

        filters.split('.').forEach((filterItem) => {
            if(filterItem !== '') {
                filterItem = '.' + filterItem;
                if(document.querySelector('.filter-input[data-toggle="' + filterItem + '"]')) {
                    document.querySelector('.filter-input[data-toggle="' + filterItem + '"]').checked = true;
                }
            }
        });

        setTimeout(() => {
            setCounters();
        }, 250);

        return getFilterString();
    }

    const setCounters = () => {
        document.querySelectorAll('.filter-input').forEach((element) => {
            const filterString = getFilterString({
                name:   element.name,
                values: [element.dataset.toggle]
            });

            const elements = Array.from(document.querySelectorAll(filterString));
            if(elements.length === 0) {
                if(element.parentNode.querySelector('.count')) {
                    element.parentNode.style.opacity                     = '0.3';
                    element.parentNode.querySelector('.count').innerHTML = '(' + elements.length + ')';
                }
            } else {
                if(element.parentNode.querySelector('.count')) {
                    element.parentNode.style.opacity                     = '1';
                    element.parentNode.querySelector('.count').innerHTML = '(' + elements.length + ')';
                }
            }
        });

        if(document.querySelector('.products-count')) {
            document.querySelector('.products-count').innerHTML = '(' + Array.from(document.querySelectorAll('.filter-item')).filter((s) =>
                window.getComputedStyle(s).getPropertyValue('display') !== 'none'
            ).length + '/' + document.querySelectorAll('.filter-item').length + ')';
        }

        // Put choices behind the dropdown-menu element on product variation filter.
        if(document.querySelector('button#size .choices')) {
            const values                                             = Array.from(document.querySelectorAll('[name="size"]:checked')).map((el) => el.value).join(', ');
            document.querySelector('button#size .choices').innerHTML = values !== '' ? '(' + values + ')' : '';
        }
    }

    const getFilterString = (appendObject) => {
        let ands = [];
        let ors  = [];
        let result;
        document.querySelectorAll('.filter-items input:checked').forEach((element) => {
            if(element.dataset['action'] === 'or') {
                ors.push(element.dataset.toggle);
            } else if(element.dataset['action'] === 'and') {
                result = ands.find(item => item.name === element.name);
                if(typeof result === 'undefined') {
                    ands.push({
                        name:   element.name,
                        values: [element.dataset.toggle]
                    });
                } else {
                    result.values.push(element.dataset.toggle);
                }
            }
        });

        if(appendObject) {
            result = ands.find(item => item.name === appendObject.name);
            if(typeof result === 'undefined') {
                ands.push(appendObject)
            } else {
                result.values = appendObject.values;
            }
        }

        let toCombine = [];
        for(let i in ands) {
            toCombine.push(ands[i].values);
        }

        if(ors.length > 0) {
            toCombine.push(ors);
        }

        if(toCombine.length > 0) {
            ors = combineArrays(toCombine);
        }

        let filterString = '';
        if(ors.length === 0 && ands.length > 0) {
            filterString = ands.join('');
        } else {
            filterString = ors.join(', ');
        }

        return filterString === '' ? '.filter-item' : filterString;
    }

    const containerEl = document.querySelector('.filter-container');
    const mixer       = Mixitup(containerEl, {
        selectors: {
            target:  '.filter-item',
            control: '.filter-input'
        },
        controls:  {
            enable:      false,
            toggleLogic: 'and'
        },
        animation: {
            duration: 300,
            easing:   'cubic-bezier(0.645, 0.045, 0.355, 1)'
        },
        load:      {
            filter: extractProductFiltersFromUrl()
        },
        callbacks: {
            onMixEnd: function(state) {
                let filterValues = [];

                document.querySelectorAll('.filter-items input:checked').forEach((element) => {
                    if(element.dataset.toggle) {
                        filterValues.push(element.dataset.toggle.replace(/^\./, ''));
                    }
                });
                if(filterValues.length > 0) {
                    const queryString = '?filters=' + filterValues.join(',');
                    history.pushState(null, document.title, window.location.pathname + queryString);
                } else {
                    history.pushState(null, document.title, window.location.pathname);
                }

                setCounters();
            }
        }
    });

    window.addEventListener('popstate', (event) => {
        let filters = extractProductFiltersFromUrl();
        if(mixer.getState().activeFilter.selector === filters) return;
        mixer.filter(filters);
    });

    document.querySelectorAll('.filter-input').forEach((element) => {
        let elements = document.querySelectorAll(element.dataset.toggle);
        if(element.parentNode.querySelector('.count')) {
            if(elements.length === 0) {
                element.parentNode.classList.add('d-none');
            } else {
                element.parentNode.querySelector('.count').innerHTML = '(' + elements.length + ')';
            }
        }
    });

    document.querySelectorAll('.filter-items input').forEach((element) => {
        element.addEventListener('change', (e) => {
            e.preventDefault();

            updateProductFilter();
        });
    });

    const updateProductFilter = () => {
        mixer.filter(getFilterString());
    }
}

if(document.querySelector('.page-body')) {
    document.querySelectorAll('.page-body').forEach((item) => {
        item.querySelectorAll('img').forEach((image) => {
            image.classList.add('img-fluid');

            if(image.style.float === 'right') {
                image.style.marginLeft   = '15px';
                image.style.marginBottom = '15px';
                image.style.marginRight  = '0';
            } else if(image.style.float === 'left') {
                image.style.marginRight  = '15px';
                image.style.marginBottom = '15px';
                image.style.marginLeft   = '0';
            }
        });

        item.querySelectorAll('table').forEach((table) => {
            table.classList.add('table', 'table-striped', 'table-hover', 'table-sm');
            table.border = 0;

            if(!table.parentNode.classList.contains('table-responsive')) {
                let wrapper       = document.createElement('div');
                wrapper.className = 'table-responsive';

                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }

            table.querySelectorAll('tr').forEach((tr) => {
                tr.style.height = 'auto';
            });

            table.querySelectorAll('td').forEach((td) => {
                td.style.height = 'auto';
            });

            table.querySelectorAll('p').forEach((p) => {
                p.style.marginBottom = 0;
            });
        });

        item.querySelectorAll('iframe').forEach((iframe) => {
            if(iframe.src.match(/youtube|youtu/)) {
                if(!iframe.parentNode.classList.contains('ratio')) {
                    let wrapper       = document.createElement('div');
                    wrapper.className = 'ratio ratio-16x9';

                    iframe.parentNode.insertBefore(wrapper, iframe);
                    wrapper.appendChild(iframe);
                }
            }
        });
    });
}

if(document.querySelector('.tab-links')) {
    document.querySelectorAll('.tab-links > a').forEach((el) => {
        el.addEventListener('click', (event) => {
            event.preventDefault();

            if(document.querySelector(event.currentTarget.dataset.target + '-tab')) {
                document.querySelector(event.currentTarget.dataset.target + '-tab').dispatchEvent(
                    new Event('click')
                );

                const y = document.querySelector('#v-pills-tab').getBoundingClientRect().top + window.scrollY - 150;

                scroll({
                    top:      y,
                    behavior: "smooth"
                });
            }
        });
    });
}

if(window.location.hash) {
    setTimeout(() => {
        const hash = window.location.hash;
        if(document.querySelector(hash)) {
            const y = document.querySelector(hash).parentNode.getBoundingClientRect().top + window.scrollY - 150;

            scroll({
                top:      y,
                behavior: "smooth"
            });
        }
    }, 400);
}

// Smooth scroll
if(document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const href      = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).getBoundingClientRect().top + window.scrollY - document.querySelector('nav.navbar').scrollHeight

            scroll({
                top:      offsetTop,
                behavior: "smooth"
            });
        });
    });
}

// init Masonry
if(document.querySelector('.grid')) {
    let grid      = document.querySelector('.grid');
    const masonry = new Masonry(grid, {
        itemSelector:    '.grid-item',
        columnWidth:     '.grid-sizer',
        percentPosition: true,
        gutter:          '.gutter-sizer'
    });

    imagesLoaded(grid).on('progress', function() {
        // layout Masonry after each image loads
        masonry.layout();
    });

    if(document.querySelector('.btn-filter')) {
        function extractFiltersFromUrl() {
            let filters = '.' + location.search.replace(/^\?filters=/, '').replace(/,/g, ',.');

            if(filters === '.') {
                filters = '.filter-item';
            }

            document.querySelectorAll('.filter-input').forEach(filterItem => {
                filterItem.checked = false;
            });

            filters.split(',.').forEach((filterItem, i) => {
                if(filterItem !== '') {
                    filterItem = (!filterItem.startsWith('.') ? '.' : '') + filterItem;
                    if(document.querySelector('.filter-input[data-toggle="' + filterItem + '"]')) {
                        document.querySelector('.filter-input[data-toggle="' + filterItem + '"]').click();
                    }
                }
            });

            updateFilter();
        }

        extractFiltersFromUrl();

        document.querySelectorAll('.filter-items input').forEach((element) => {
            element.addEventListener('change', (e) => {
                e.preventDefault();
                document.querySelectorAll('.filter-items input:checked:not([data-toggle="' + e.target.dataset.toggle + '"])').forEach((el) => {
                    el.checked = false;
                });
                updateFilter();
            });
        });

        function updateFilter() {
            let searchQuery = '';

            let ands = [];
            let ors  = [];
            document.querySelectorAll('.filter-items input:checked').forEach((element) => {
                if(element.dataset['action'] === 'or') {
                    ors.push(element.dataset.toggle);
                } else if(element.dataset['action'] === 'and') {
                    ands.push(element.dataset.toggle);
                }
            });

            if(ands.length > 0 && ors.length > 0) {
                for(let i in ands) {
                    for(let u in ors) {
                        ors[u] = ands[i] + ors[u];
                    }
                }
            }

            let filterString = '';
            if(ors.length === 0 && ands.length > 0) {
                filterString = ands.join('');
            } else {
                filterString = ors.join(', ');
            }

            filterString = filterString === '' ? 'all' : filterString;
            filterString = filterString === 'all' && searchQuery === '' ? 'all' : filterString;

            const elements = Array.from(document.querySelectorAll((filterString !== 'all' ? filterString : '.filter-item')));
            const filtered = elements.filter((target) => {
                if(target.hasAttribute('data-search')) {
                    let regex = new RegExp(searchQuery.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$]/g, "\\$&"), 'gi');
                    return target.getAttribute('data-search').match(regex);
                }

                return true;
            });

            const allElements    = Array.from(document.querySelectorAll('.filter-item'));
            const hiddenElements = allElements.filter((target) => {
                return !filtered.includes(target);
            }).map((target) => {
                target.style.display = 'none';
            });

            filtered.map((target) => {
                target.style.display = 'block';
            });

            masonry.layout();

            let filterValues = [];
            document.querySelectorAll('.filter-items input:checked').forEach(element => {
                filterValues.push(element.dataset.toggle.replace(/^\./, ''));
            });
            if(filterValues.length > 0) {
                const queryString = '?filters=' + filterValues.join(',');
                history.pushState(null, document.title, window.location.pathname + queryString);
            } else {
                history.pushState(null, document.title, window.location.pathname);
            }
        }
    }
}

// Add and remove class on scroll
if(document.querySelector('.logo')) {
    let scrollpos      = window.scrollY
    var header         = document.querySelector(".logo")
    const headerHeight = header.offsetHeight

    const addClassOnScroll    = () => header.classList.add("logo-shrink")
    const removeClassOnScroll = () => header.classList.remove("logo-shrink")

    window.addEventListener('scroll', function() {
        scrollpos = window.scrollY;

        if(scrollpos >= headerHeight) {
            addClassOnScroll()
        } else {
            removeClassOnScroll()
        }
    });
}

// Flickity
if(document.querySelector('.related-posts-carousel')) {
    var flkty = new Flickity('.related-posts-carousel', {
        cellAlign:      'left',
        contain:        true,
        wrapAround:     true,
        groupCells:     true,
        arrowShape:     '',
        setGallerySize: false
    });

    const slides                       = document.querySelectorAll('.related-posts-carousel .carousel-cell');
    const handleFlickityViewportChange = () => {
        slides.forEach(slide => slide.style.height = '');

        let heights = Array.from(slides).map((slide) => slide.scrollHeight),
            max     = Math.max(...heights);

        slides.forEach((slide) => slide.style.height = max + 'px');
        document.querySelector('.related-posts-carousel .flickity-viewport').style.height = (max + 50) + 'px';
    }
    window.addEventListener('resize', handleFlickityViewportChange);
    window.addEventListener('DOMContentLoaded', handleFlickityViewportChange);
}

// Flickity product images
if(document.querySelector('.product-images-main')) {
    var flktyA = new Flickity('.product-images-main', {
        arrowShape: '',
        fade:       true,
        pageDots:   false,
        fullscreen: true
    });
    var flktyB = new Flickity('.product-images-nav', {
        asNavFor:        '.product-images-main',
        contain:         true,
        pageDots:        false,
        prevNextButtons: false
    });
}

// Flickity DINA Sleep
if(document.querySelector('.dinasleep-carousel')) {
    var flktyA = new Flickity('.dinasleep-carousel', {
        arrowShape: '',
        fade:       true,
        pageDots:   false,
    });
}

// Youtube custom play btn
setInterval(function() {
    if(document.activeElement instanceof HTMLIFrameElement) {
        document.getElementById('video-cover').style.opacity  = 0;
        document.getElementById('video-player').style.opacity = 1;
    }
}, 50);

if(document.querySelector('.nav-pills .nav-link')) {
    document.querySelectorAll('.nav-pills .nav-link').forEach((el) => {
        el.addEventListener('click', (event) => {
            document.location.hash = event.target.href.replace(/^.*#(.*)$/, '$1');
        });
    });

    const handleHashChange = () => {
        if(window.location.hash !== '') {
            if(document.querySelector(window.location.hash)) {
                document.querySelector('[href="' + window.location.hash + '"]').dispatchEvent(
                    new Event('click')
                );
            }
        }
    }

    handleHashChange();

    window.addEventListener('hashchange', handleHashChange);
}

// Modulobox
var modulobox = new ModuloBox({
    mediaSelector:      '.gallery figure > a, .hidden-gallery div, a.open-gallery',
    loop:               3,
    history:            true,
    controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
    shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
    videoMaxWidth:      1920,
    videoAutoPlay:      true,
    minZoom:            1,
    zoomTo:             1.8,
    mouseWheel:         false,
    contextMenu:        false,
    scrollToZoom:       true,
    captionSmallDevice: false,
    thumbnails:         true,
    thumbnailsNav:      'centered',
    thumbnailSizes:     {
        1920: {
            width:  110,
            height: 80,
            gutter: 10
        },
        1280: {
            width:  90,
            height: 65,
            gutter: 10
        },
        680:  {
            width:  0,
            height: 0,
            gutter: 0
        }
    }
});

modulobox.on('beforeOpen.modulobox', function(gallery, index) {
    if(window.cubeRAF) {
        cancelAnimationFrame(window.cubeRAF);
        window.cubeRAF = false;
    }
});

modulobox.on('afterClose.modulobox', function(gallery, index) {
    if(typeof Event === 'function' && !window.cubeRAF) {
        window.dispatchEvent(new Event('scroll'));
    }
});

modulobox.init();

if(document.querySelector('.closing-the-loop')) {
    const parent      = document.querySelector('.parent-circle')
    const innerCircle = document.querySelectorAll('.circle-content')
    const circle      = document.querySelectorAll('.circle')
    const text        = document.querySelectorAll('.textbox')

    circle.forEach((el) => {
        const deg     = el.dataset.degrees;
        const textBox = el.dataset.text;
        el.addEventListener('click', () => {
            parent.style.transform = `rotate( -${deg}deg)`;

            document.querySelector('.circle.active').classList.remove('active');
            el.classList.add('active');

            text.forEach((el) => {
                el.classList.replace("opacity-100", "opacity-0");
                if(textBox === el.dataset.text) {
                    el.classList.replace("opacity-0", "opacity-100");
                }
            });

            innerCircle.forEach((el) => {
                el.style.transform = `rotate( ${deg}deg)`;
            });
        });
    });

    document.querySelector('.navigate-previous').addEventListener('click', () => {
        navigateItem("previous")
    });
    document.querySelector('.navigate-next').addEventListener('click', () => {
        navigateItem("next")
    });

    function navigateItem(direction) {
        const activeEl = document.querySelector('.circle.active');
        let number;

        if(direction === "previous") {

            number = (parseFloat(activeEl.dataset.text) > 1) ? parseFloat(activeEl.dataset.text) - 1 : 6;
        } else {

            number = (parseFloat(activeEl.dataset.text) < 6) ? parseFloat(activeEl.dataset.text) + 1 : 1;
        }

        const newItem = document.querySelector(`[data-text="${number}"]`)

        document.querySelector('.circle.active').classList.remove('active');
        newItem.classList.add('active');

        const angle            = newItem.dataset.degrees;
        parent.style.transform = `rotate( -${angle}deg)`;
        innerCircle.forEach((el) => {
            el.style.transform = `rotate( ${angle}deg)`;
        });

        text.forEach((el) => {
            el.classList.replace("opacity-100", "opacity-0");
            if(number == el.dataset.text) {
                el.classList.replace("opacity-0", "opacity-100");
            }
        });
    };
}

if(document.querySelector('.lift-scroll-img')) {
    gsap.to(".case-img", {
        left:          "-38%",
        top:           "-30%",
        scale:         "1.2",
        ease:          "power2.inOut",
        scrollTrigger: {
            trigger: ".lift-scroll-img",
            start:   "bottom bottom",
            end:     "top top",
            scrub:   true,
            //   markers: true
        }
    });
}
